import Features from "@app/feature-flags/features";
import Roles from "@app/user/roles";

// Eligible when the Public flag is on and the user holds ACCURACY_LICENSE_TIER_2,
// OR when the Beta flag is on and the user holds the NewProviderReportBeta role.
export function isNewProviderReportEligible(enabledFeatureFlags: Set<string>, userRoles: string[]): boolean {
  const publicFlagOn = enabledFeatureFlags.has(Features.NEW_PROVIDER_REPORT_PUBLIC);
  const betaFlagOn = enabledFeatureFlags.has(Features.NEW_PROVIDER_REPORT_BETA);
  const hasTier2 = userRoles.includes(Roles.ACCURACY_LICENSE_TIER_2);
  const hasBetaRole = userRoles.includes(Roles.NEW_PROVIDER_REPORT_BETA);
  return (publicFlagOn && hasTier2) || (betaFlagOn && hasBetaRole);
}
